import { NextFunction, Request, RequestHandler, Response } from "express";
import httpStatus from "http-status";

export const catchAsync = (fn: RequestHandler) => {
  return async (req: Request, res: Response, next: NextFunction) => {
    try {
      await fn(req, res, next);
    } catch (error: any) {
      // res.status(httpStatus.INTERNAL_SERVER_ERROR).json({
      //   success: false,
      //   statusCode: httpStatus.INTERNAL_SERVER_ERROR,
      //   message:
      //     error?.code === "P2025"
      //       ? "No record was founded!"
      //       : "Something went wrong.",
      //   error: (error as Error).message,
      //   willDelete: error,
      // });
      next(error);
    }
  };
};
